import { EditVestidosComponent } from './pages/vestidos/edit-vestidos/edit-vestidos.component';
import { UsersComponent } from './pages/usuarios/list/users.component';
import { SignupComponent } from './pages/registro/signup.component';
import { LoginComponent } from './pages/iniciar-sesion/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './shared/auth/auth.guard';
import { EditUserComponent } from './pages/usuarios/edit-user/edit-user.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ListPlatosComponent } from './pages/platos/list-platos/list-platos.component';
import { EditPlatoComponent } from './pages/platos/edit-plato/edit-plato.component';
import { ListIngredientesCondimentosComponent } from './pages/platos/list-ingredientes-condimentos/list-ingredientes-condimentos.component';
import { ListNeverasComponent } from './pages/neveras/list-neveras/list-neveras.component';
import { EditNeverasComponent } from './pages/neveras/edit-neveras/edit-neveras.component';
import { ConfirmDeactivateGuardGuard } from './shared/confirm-deactivate-guard.guard';

const routes: Routes = [
  { path: 'iniciar-sesion', component: LoginComponent },
  /* Deshabilitar registro { path: 'registro', component: SignupComponent },*/
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'editor'] },
  },
  {
    path: 'usuarios',
    component: UsersComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin'] },
  },
  {
    path: 'usuarios/editar/:id',
    component: EditUserComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin'] },
  },
  {
    path: 'platos',
    component: ListPlatosComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'editor'] },
  },
  {
    path: 'platos/editar',
    component: EditPlatoComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuardGuard],
    data: { roles: ['admin', 'editor'] },
  },
  {
    path: 'platos/editar/:url_slug',
    component: EditPlatoComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuardGuard],
    data: { roles: ['admin', 'editor'] },
  },
  {
    path: 'ingredientes-condimentos',
    component: ListIngredientesCondimentosComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'editor'] },
  },
  {
    path: 'neveras',
    component: ListNeverasComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'editor'] },
  },
  {
    path: 'neveras/editar',
    component: EditNeverasComponent,
    canActivate: [AuthGuard],
    data: { roles: ['admin', 'editor'] },
  },
  {
    path: 'neveras/editar/:url_slug',
    component: EditNeverasComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuardGuard],
    data: { roles: ['admin', 'editor'] },
  },
  {
    path: '**',
    pathMatch: 'full',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
